export const POLICY_SIDEBAR_FACTS = [
  {
    icon: 'fa-user-shield',
    title: 'Protección de derechos',
    description:
      'El tratamiento de la información se realizará respetando los derechos y libertades de los titulares.',
  },
  {
    icon: 'fa-file-signature',
    title: 'Autorización informada',
    description:
      'La información será tratada conforme a las finalidades informadas y a la autorización correspondiente.',
  },
  {
    icon: 'fa-lock',
    title: 'Seguridad',
    description:
      'Se adoptarán medidas razonables para proteger la confidencialidad, integridad y disponibilidad de la información.',
  },
  {
    icon: 'fa-headset',
    title: 'Canales de atención',
    description:
      'Los titulares podrán presentar consultas, actualizaciones, correcciones o reclamos mediante los canales institucionales.',
  },
];
